import React from 'react';
import styles from './TypeSelector.module.scss';
import CheckIcon from '../../../assets/iconsTsx/CheckIcon.tsx';
import AnteProyectoIcon from '../../../assets/iconsTsx/AnteProyectoIcon.tsx';
import ProyectoIcon from '../../../assets/iconsTsx/ProyectoIcon.tsx';

interface TypeSelectorProps {
  selectedType: 'proyecto' | 'anteproyecto' | null;
  onSelect: (type: 'proyecto' | 'anteproyecto') => void;
}

const TypeSelector: React.FC<TypeSelectorProps> = ({
  selectedType,
  onSelect
}) => {
  const types = [
    {
      id: 'anteproyecto',
      name: 'Ante Proyecto',
      description: 'Idea o concepto preliminar de proyecto',
      Icon: AnteProyectoIcon
    },
    {
      id: 'proyecto',
      name: 'Proyecto',
      description: 'Documentación completa de obra',
      Icon: ProyectoIcon
    }
  ];

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h2 className={styles.title}>Selecciona el tipo de documentación</h2>
        <p className={styles.description}>
          Elige el tipo según el nivel de desarrollo de tu proyecto
        </p>
      </div>

      <div className={styles.typesGrid}>
        {types.map((type) => (
          <div
            key={type.id}
            className={`${styles.typeCard} ${
              selectedType === type.id ? styles.selected : ''
            }`}
            onClick={() => onSelect(type.id as 'proyecto' | 'anteproyecto')}
          >
            <div className={styles.typeIcon}>
              <type.Icon className={styles.icon} />
            </div>
            <h3 className={styles.typeName}>{type.name}</h3>
            <p className={styles.typeDescription}>{type.description}</p>

            {selectedType === type.id && (
              <div className={styles.checkmark}>
                <CheckIcon className={styles.checkIcon} />
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default TypeSelector;
